MessageFormat.locale.en=function(n){return n===1?"one":"other"}
